import Button from "@app/components/move2Library/Button/Button"
import { useGetStrings } from "@app/store/service/cmsService"
import { getPriceString } from "@app/utils/localeUtils"
import { emptyArray } from "@app/utils/objectUtils"
import { classNamez, useViewport } from "@tecreation/funnel-components"
import { useEffect, useRef } from "react"
import "./ContentFooter.css"

/**
 *
 * @param {{ children, className, price,priceAbsolute: boolean, onNext, buttonProps: {text,disabled,isLoading,onNext, disabledReason} }} param0
 * @returns
 */
const ContentFooter = ({ className, roundPrice, price, priceAbsolute, buttonProps, children, process, center, showPayPal }) => {
	const { sm, lg, xl } = useViewport()

	const { data } = useGetStrings()
	const { from, bookingFooterLabel, buttonNext, buttonNowAvailableLabel } = data || {}
	buttonProps = buttonProps || {}

	const previousDisabledRef = useRef(buttonProps.disabled)
	const statusMessageRef = useRef(null)

	useEffect(() => {
		let timeoutId
		// Announce when button becomes enabled
		if (previousDisabledRef.current && !buttonProps.disabled && statusMessageRef.current) {
			// Add delay for main content announcements to finish
			timeoutId = setTimeout(() => {
				statusMessageRef.current.textContent = (buttonProps.text || buttonNext) + buttonNowAvailableLabel
			}, 500)
		}
		previousDisabledRef.current = buttonProps.disabled

		return () => {
			if (timeoutId) {
				clearTimeout(timeoutId)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [buttonProps.disabled, buttonProps.text])

	return (
		<div
			className={
				"contentFooter mt-auto p-4 flex flex-items-center border-top color-border-primary border-lg-0 px-lg-8  bold relative color-bg-default color-fg-primary flex-justify-between " +
				className +
				classNamez({
					"flex-justify-between": !center,
					"flex-justify-center": center,
				})
			}
			role="region"
			aria-label={bookingFooterLabel}
		>
			<div className="color-fg-">
				{price !== undefined && (
					<h2 className="h-without-default-style" aria-label="price" aria-describedby="footer-price-string">
						{!priceAbsolute && <span className="medium">{from} </span>}
						<span id="footer-price-string" className="f2 f-lg-1 medium">
							{getPriceString(price < 0 ? 0 : price, undefined, roundPrice)}
						</span>
					</h2>
				)}
			</div>

			{process !== undefined && !sm && (
				<div
					className="flex flex-center fill"
					style={{
						gap: "8px",
						position: "absolute",
						left: "0",
						top: lg ? "-20px" : "40px",
						pointerEvents: "none",
					}}
				>
					{emptyArray(8).map((__, i) => {
						return (
							<div
								key={i}
								className={"circle color-bg-neutral-700" + classNamez({ "color-bg-neutral-900": i === process - 1 })}
								style={{ height: "10px", width: "10px" }}
							/>
						)
					})}
				</div>
			)}

			<div className={"flex " + (showPayPal && sm ? "w-100" : "")}>
				<div aria-live="polite" className="sr-only" id="footer-status" ref={statusMessageRef} />
				{children}
				{xl && showPayPal && <div id="paypal-container" className="mr-2" />}

				<div className="w-100">
					<Button
						style={buttonProps.style ? buttonProps.style : "secondary"}
						onClick={buttonProps.onNext}
						disabled={buttonProps.disabled}
						isLoading={buttonProps.isLoading}
						disabledReason={buttonProps.disabledReason}
						fillWidth
					>
						{buttonProps.text}
					</Button>
					{!xl && showPayPal && <div id="paypal-container" className="mt-2" />}
				</div>
			</div>
		</div>
	)
}

ContentFooter.defaultProps = {
	priceAbsolute: false,
}

export { ContentFooter }
